<template>
  <b-form @submit.prevent="save">
    <b-form-group label="Name:">
      <b-form-input
        type="text"
        v-model.trim="$v.displayName.$model"
        :class="{ 'is-invalid': $v.displayName.$error }"
        autocomplete="off"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.displayName.required">
        Display Name is required
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.displayName.isUnique">
        Column with the same name already exists
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Table:"
    >
      <b-form-select
        v-model="$v.dataGrid.$model"
        :class="{ 'is-invalid': $v.dataGrid.$error }"
        :options="availableGrids"
      />
      <b-form-invalid-feedback v-if="!$v.dataGrid.required">
        Table is required
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Filter Column:"
      v-if="dataGrid"
    >
      <b-form-select
        v-model="$v.filterColumn.$model"
        :class="{ 'is-invalid': $v.filterColumn.$error }"
        :options="availableColumns"
      />
      <b-form-invalid-feedback v-if="!$v.filterColumn.required">
        Filter Column is required
      </b-form-invalid-feedback>
    </b-form-group>
    <b-button
      variant="success"
      type="submit"
      >
      Save
    </b-button>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'

export default {
  props: [
    'type',
    'gridId',
    'rowIndex',
    'sectionIndex'
  ],
  data () {
    return {
      inPorcess: false,
      displayName: null,
      dataGrid: null,
      filterColumn: null
    }
  },
  watch: {
    dataGrid () {
      this.filterColumn = null
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    availableGrids () {
      const grids = []

      for (let gridId in this.dataGrid_options) {
        grids.push({
          text: this.dataGrid_options[gridId].title,
          value: gridId
        })
      }

      return grids
    },
    availableColumns () {
      const columns = []

      if (!this.dataGrid) return columns

      const meta = this.dataGrid_options[this.dataGrid].meta

      for (let cellKey in meta) {
        columns.push({ text: meta[cellKey].displayName, value: cellKey })
      }

      return columns
    }
  },
  methods: {
    async save () {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      const data = {
        type: this.type,
        gridId: this.gridId,
        displayName: this.displayName,
        propertyName: this.$sanitize(this.displayName),
        dataGrid: this.dataGrid,
        filterColumn: this.filterColumn
      }

      await db.dataGrid.data.addColumn(data)

      this.inPorcess = false
      this.displayName = null
      this.dataGrid = null
      this.$nextTick(() => {
        this.$v.$reset()
      })

      this.$emit('submitted')
    },
  },
  validations: {
    displayName: {
      required,
      isUnique (value) {
        if (!value) return true

        for (let cellKey in this.dataGrid_options[this.gridId].meta) {
          if (this.$sanitize(value) === cellKey) return false
        }

        return true
      }
    },
    dataGrid: {
      required
    },
    filterColumn: {
      required
    }
  }
}
</script>
